export default __webpack_public_path__ + "static/media/create-team-second.8e3f75c9.jpg";